import axios from 'axios';
import { BASE_URL, ONBOARDING_BASE_URL } from './constants';

export const request = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

// Create separate request instance for onboarding endpoints
export const onboardingRequest = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for debugging
onboardingRequest.interceptors.request.use(
  function (config) {
    console.log('🔍 HTTP Request:', config.method?.toUpperCase(), config.url);
    console.log('🔍 HTTP Request data:', config.data);
    console.log('🔍 HTTP Request headers:', config.headers);
    return config;
  },
  function (error) {
    console.error('❌ HTTP Request error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging
onboardingRequest.interceptors.response.use(
  function (response) {
    console.log('✅ HTTP Response:', response.status, response.config.url);
    console.log('✅ HTTP Response data:', response.data);
    return response;
  },
  function (error) {
    console.error('❌ HTTP Response error:', error.response?.status, error.config?.url);
    console.error('❌ HTTP Response error data:', error.response?.data);
    return Promise.reject(error);
  }
);

request.defaults.baseURL = BASE_URL;
onboardingRequest.defaults.baseURL = ONBOARDING_BASE_URL;

export function setupHttpConfig() {
  // request.defaults.timeout = 5000;
  const token = localStorage.getItem('access');
  if (token) {
    request.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
}

request.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const errorResponse = error.response;
    if (isTokenExpiredError(errorResponse)) {
      return resetTokenAndReattemptRequest(error);
    }

    return Promise.reject(error);
  }
);

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function isTokenExpiredError(errorResponse) {
  return errorResponse.data.code === 'token_not_valid';
}

async function resetTokenAndReattemptRequest(error) {
  try {
    const { response: errorResponse } = error;
    const resetToken = localStorage.getItem('refresh');
    if (!resetToken) {
      return Promise.reject(error);
    }
    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber((access_token) => {
        errorResponse.config.headers.Authorization = 'Bearer ' + access_token;
        resolve(axios(errorResponse.config));
      });
    });

    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true;
      const response = await axios({
        method: 'post',
        url: `${BASE_URL}/token/refresh`,
        data: {
          refresh: resetToken,
        },
      });
      if (!response.data) {
        return Promise.reject(error);
      }

      const { access, refresh } = response.data;
      localStorage.setItem('access', access);
      if (refresh) {
        localStorage.setItem('refresh', refresh);
      }
      setupHttpConfig();
      isAlreadyFetchingAccessToken = false;
      onAccessTokenFetched(access);
    }
    return retryOriginalRequest;
  } catch (err) {
    localStorage.clear();
    return Promise.reject(err);
  }
}

function onAccessTokenFetched(access_token) {
  subscribers.forEach((callback) => callback(access_token));
  subscribers = [];
}

function addSubscriber(callback) {
  subscribers.push(callback);
}
